import { UserWaizenOnboarding } from 'generated/graphql';
import { QualityOnboarding } from 'Interfaces/User/UserData';

const convertToQualityOnboarding = (userWaizenOnboarding: UserWaizenOnboarding): QualityOnboarding => {
    return {
        connectToApplication: userWaizenOnboarding?.connectToApplication,
        createRubrics: userWaizenOnboarding?.createRubrics,
        setupExtension: userWaizenOnboarding?.setupExtension,
        setupTeam: userWaizenOnboarding?.setupTeam,
    };
};

export default convertToQualityOnboarding;
